import React , {useEffect} from 'react'
import Navbar from '../../components/Navbar/Navbar'
import DetailTermsCondition from '../../components/DetailTermsCondition/DetailTermsCondition'
import Footer from '../../components/Footer/Footer'
function TermsCondition() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div style={{overflow:'hidden'}}>
      <Navbar/>
      <DetailTermsCondition/>
      <Footer/>
    </div>
  )
}

export default TermsCondition